module.exports = __webpack_public_path__ + "static/img/ic_ticket.639b2651.png";